(() => {
  if (window.__avonticLiveSupportLoaded) return;
  window.__avonticLiveSupportLoaded = true;

  const CHAT_SELECTOR = 'shopify-chat';
  const OPEN_TRIGGER = '[data-av-open-chat]';
  const STATUS_SELECTOR = '[data-av-chat-status]';
  const SUPPORT_EVENT = 'avontic_support_intent';

  const contextFor = (trigger) => ({
    intent: trigger?.dataset.avSupportIntent || '',
    placement: trigger?.dataset.avSupportPlacement || 'unknown',
    product: trigger?.dataset.avSupportProduct || '',
    collection: trigger?.dataset.avSupportCollection || '',
    path: window.location.pathname
  });

  const track = (channel, trigger) => {
    const detail = { channel, ...contextFor(trigger) };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: SUPPORT_EVENT, ...detail });
    document.dispatchEvent(new CustomEvent('avontic:support-intent', { detail }));
  };

  const setStatus = (trigger, message) => {
    const container = trigger?.closest('[data-av-support]') || document;
    const status = container.querySelector(STATUS_SELECTOR);
    if (status) status.textContent = message;
  };

  const openChat = (trigger) => {
    const chat = document.querySelector(CHAT_SELECTOR);
    if (!chat) return false;

    const detail = contextFor(trigger);
    document.dispatchEvent(new CustomEvent('avontic:specialist-context', { detail }));
    chat.setAttribute('open', '');
    trigger?.setAttribute('aria-expanded', 'true');
    trigger?.removeAttribute('aria-busy');
    if (trigger) delete trigger.dataset.avChatFallback;
    setStatus(trigger, 'Support chat opened.');
    track('specialist_chat', trigger);
    return true;
  };

  const waitForChat = (trigger, { announce = true } = {}) => {
    if (openChat(trigger)) return;

    trigger?.setAttribute('aria-busy', 'true');
    if (announce) setStatus(trigger, 'Opening support chat…');

    const observer = new MutationObserver(() => {
      if (!openChat(trigger)) return;
      observer.disconnect();
      window.clearTimeout(timeoutId);
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    const timeoutId = window.setTimeout(() => {
      observer.disconnect();
      trigger?.removeAttribute('aria-busy');
      if (trigger?.matches('a[href]')) trigger.dataset.avChatFallback = 'true';
      setStatus(trigger, 'Chat is unavailable right now. Select this link again to contact our support team.');
    }, 5000);
  };

  document.addEventListener('click', (event) => {
    const chatTrigger = event.target.closest(OPEN_TRIGGER);

    if (chatTrigger) {
      if (chatTrigger.dataset.avChatFallback === 'true') {
        track('support_hub_fallback', chatTrigger);
        return;
      }
      event.preventDefault();
      waitForChat(chatTrigger);
      return;
    }

    const channelLink = event.target.closest('[data-av-support-channel]');
    if (channelLink) track(channelLink.dataset.avSupportChannel, channelLink);
  });

  const autoOpenFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('open_chat') !== '1') return;

    const trigger = document.querySelector(OPEN_TRIGGER);
    if (!trigger) return;
    const intent = params.get('intent');
    const product = params.get('product');
    const collection = params.get('collection');
    if (intent) trigger.dataset.avSupportIntent = intent;
    if (product) trigger.dataset.avSupportProduct = product;
    if (collection) trigger.dataset.avSupportCollection = collection;
    waitForChat(trigger, { announce: false });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoOpenFromUrl, { once: true });
  } else {
    autoOpenFromUrl();
  }
})();
